export default __webpack_public_path__ + "static/media/remove-circle.0a10bad0.svg";